module.exports = __webpack_public_path__ + "static/img/56-3.8c09076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/56-3.jpg
// module id = FwZP
// module chunks = 0